import React, { useEffect, useState } from 'react';
import Header from './Header';
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { QrScanner } from '@yudiel/react-qr-scanner';
import { toast } from 'react-toastify';

function Scan() {
  const [data, setData] = useState('');
  const [scanning, setScanning] = useState(true);
  const navigate = useNavigate();

  const handleQrScanner = (result) => {
    try{
      const id = JSON.parse(result)._id;
      if (result) {
        // setScanning(false);
        setData(id);
        navigate(`/booking-details/${id}`, { replace: true });
      }
    }catch(error){
      toast.error('Invalid QR code please scan valid QR!');
      navigate('/');
    }
  };
  useEffect(() => {
    setScanning(true);
  }, []);
  return (
    <>
      <Header />
      <div className='d-flex scaner-head mt-0 mt-md-4'>
        <div className='d-flex flex-grow-1 custom-border pb-2'>
          <div className='w-50'>
            <Button
              type='button'
              className='bg-transparent border-0 p-0'
              onClick={() => {
                setScanning(false);
                navigate(-1);
              }}
            >
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='32'
                height='32'
                viewBox='0 0 32 32'
                fill='none'
              >
                <path
                  d='M25.3334 14.6667H10.4401L16.9467 8.16C17.4667 7.64 17.4667 6.78666 16.9467 6.26666C16.8234 6.14306 16.6769 6.045 16.5156 5.97809C16.3543 5.91118 16.1814 5.87674 16.0067 5.87674C15.8321 5.87674 15.6592 5.91118 15.4979 5.97809C15.3366 6.045 15.1901 6.14306 15.0667 6.26666L6.28006 15.0533C6.15646 15.1767 6.05839 15.3232 5.99149 15.4845C5.92458 15.6458 5.89014 15.8187 5.89014 15.9933C5.89014 16.168 5.92458 16.3409 5.99149 16.5022C6.05839 16.6635 6.15646 16.81 6.28006 16.9333L15.0667 25.72C15.1902 25.8434 15.3367 25.9414 15.498 26.0082C15.6593 26.075 15.8322 26.1094 16.0067 26.1094C16.1813 26.1094 16.3542 26.075 16.5155 26.0082C16.6767 25.9414 16.8233 25.8434 16.9467 25.72C17.0702 25.5966 17.1681 25.45 17.2349 25.2887C17.3017 25.1274 17.3361 24.9546 17.3361 24.78C17.3361 24.6054 17.3017 24.4326 17.2349 24.2713C17.1681 24.11 17.0702 23.9634 16.9467 23.84L10.4401 17.3333H25.3334C26.0667 17.3333 26.6667 16.7333 26.6667 16C26.6667 15.2667 26.0667 14.6667 25.3334 14.6667Z'
                  fill='black'
                />
              </svg>
            </Button>
          </div>
          <div className='w-50 fs-4 fw-bold'>Scan</div>
        </div>
      </div>

      <div className='d-flex flex-grow-1 justify-content-center px-0 scanner'>
        {scanning && (
          <div className='my-auto'>
            <QrScanner
              onDecode={handleQrScanner}
              onError={(error) => {
                console.log(error);
                // setScanning(false);
                // navigate('/');
              }}
              containerStyle={{
                height: '250px',
                width: '250px',
              }}
              videoStyle={{ height: '250px', width: '250px' }}
              viewFinderBorder={1}
              // tracker={true}
            />
          </div>
        )}
        {/* <p>{data}</p> */}
      </div>
    </>
  );
}

export default Scan;
